/*
 * Home page and collection grid: product photos have inconsistent white margins baked in (and many
 * are 2:3 portrait inside square boxes), so the same box shows some products small and others large.
 * Measure the non-white area of each photo and scale/centre it so every product fills the same share
 * of its box.
 */
(function () {
  if (window.homeImageFit) return; // loaded by both the home and collection sections
  var SELECTOR = [
    '.section-new-arrivals .tile-image',
    '.section-shop-products .tile-image',
    '.product-grid .new-product-tile .tile-image',
  ].join(',');
  var FILL = 0.9; // share of the box the product's larger side should occupy
  var MAX_SCALE = 3;
  var SIZE = 120; // analysis canvas size (long side)
  var WHITE = 236; // channel value above which a pixel counts as background

  function measure(source, boxW, boxH) {
    var w = source.naturalWidth;
    var h = source.naturalHeight;
    if (!w || !h || !boxW || !boxH) return null;

    // Same geometry as object-fit: contain inside a boxW x boxH box, at analysis resolution
    var k = SIZE / Math.max(boxW, boxH);
    var cw = Math.max(1, Math.round(boxW * k));
    var ch = Math.max(1, Math.round(boxH * k));
    var ratio = Math.min(cw / w, ch / h);
    var dw = w * ratio;
    var dh = h * ratio;

    var canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, cw, ch);
    ctx.drawImage(source, (cw - dw) / 2, (ch - dh) / 2, dw, dh);

    var data = ctx.getImageData(0, 0, cw, ch).data; // throws if the canvas is tainted
    var minX = cw, minY = ch, maxX = -1, maxY = -1;
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        var i = (y * cw + x) * 4;
        if (data[i] < WHITE || data[i + 1] < WHITE || data[i + 2] < WHITE) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    return {
      left: minX / cw,
      top: minY / ch,
      width: (maxX - minX + 1) / cw,
      height: (maxY - minY + 1) / ch,
      boxRatio: boxW / boxH,
    };
  }

  function apply(img, box) {
    if (!box) {
      img.style.transform = '';
      return;
    }
    var scale = Math.min(FILL / box.width, FILL / box.height, MAX_SCALE);
    if (scale < 1) scale = 1;
    var cx = box.left + box.width / 2;
    var cy = box.top + box.height / 2;
    img.style.transformOrigin = (cx * 100).toFixed(2) + '% ' + (cy * 100).toFixed(2) + '%';
    img.style.transform =
      'translate(' + ((0.5 - cx) * 100).toFixed(2) + '%, ' + ((0.5 - cy) * 100).toFixed(2) + '%) scale(' + scale.toFixed(3) + ')';
  }

  function fit(img) {
    if (!img || !img.matches || !img.matches(SELECTOR)) return;
    if (!img.complete || !img.naturalWidth) return;
    var boxW = img.clientWidth;
    var boxH = img.clientHeight;
    if (!boxW || !boxH) return; // hidden (inactive tab); refitted when shown
    var src = img.currentSrc || img.src;
    var key = src + '@' + boxW + 'x' + boxH;
    if (img.dataset.fitKey === key) return;
    img.dataset.fitKey = key;

    try {
      apply(img, measure(img, boxW, boxH));
    } catch (e) {
      // Cross-origin without CORS headers: measure an anonymous-CORS copy instead
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        if ((img.currentSrc || img.src) !== src) return;
        try {
          apply(img, measure(probe, boxW, boxH));
        } catch (err) {
          apply(img, null);
        }
      };
      probe.src = src;
    }
  }

  // Re-fit whenever a photo's box changes size (slider/tab layout settling, breakpoints), so a zoom
  // measured against a temporary box never sticks
  var observer = window.ResizeObserver
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { fit(entry.target); });
      })
    : null;

  function fitAll() {
    document.querySelectorAll(SELECTOR).forEach(function (img) {
      if (observer && !img.dataset.fitObserved) {
        img.dataset.fitObserved = '1';
        observer.observe(img);
      }
      fit(img);
    });
  }
  window.homeImageFit = fitAll;

  // load doesn't bubble but can be captured: lazy images, swatch swaps, recently-viewed tiles
  document.addEventListener('load', function (e) { fit(e.target); }, true);
  // Tabs and sliders reveal hidden images on click
  document.addEventListener('click', function () { setTimeout(fitAll, 60); });
  window.addEventListener('resize', function () {
    clearTimeout(window.__homeFitResize);
    window.__homeFitResize = setTimeout(fitAll, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }
  window.addEventListener('load', fitAll);
})();
